
import { useQuery } from '@tanstack/react-query';
import { getCategories, getCategoriesWithDetails } from '@/services/categoryService';

export const useGetCategories = () => {
  return useQuery({
    queryKey: ['categories'],
    queryFn: getCategories
  });
};

export const useGetCategoriesWithDetails = () => {
  return useQuery({
    queryKey: ['categories-with-details'],
    queryFn: getCategoriesWithDetails
  });
};
